import { push } from "connected-react-router";
import "whatwg-fetch";
import {
  ERROR_NOTIFICATION,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
} from "../constants/ActionTypes";
import { checkHttpStatus, parseJSON } from "../utils";
import { getCookie, getCsrfCookie } from "./API";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

export function checkAuthentication() {
  return (dispatch, getState) => {
    const { isAuthenticated } = getState().auth;
    if (!isAuthenticated) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("roles");
      sessionStorage.removeItem("permissions");
    }

    if (isAuthenticated) {
      dispatch(push("/dashboard"));
    }
  };
}

export const requestLogin = () => {
  return {
    type: LOGIN_REQUEST,
  };
};

export const loginSuccess = (token) => {
  return {
    type: LOGIN_SUCCESS,
    token,
  };
};

export const loginError = (error) => {
  return {
    type: LOGIN_FAILURE,
    status: error.response.status,
    statusText: error.response.statusText,
  };
};

export const errorNotification = (error) => {
  return {
    type: ERROR_NOTIFICATION,
    isError: true,
    error,
  };
};

export function loginUser(creds, redirect = "/dashboard") {
  const xsrfToken = getCookie("XSRF-TOKEN");
  let config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": xsrfToken,
    },
    credentials: "include",
    body: JSON.stringify({ email: creds.email, password: creds.password }),
  };

  return (dispatch) => {
    dispatch(requestLogin());

    return fetch(`${apiEndpoint}/auth/authenticate`, config)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(async (response) => {
        try {
          const token = response.token;
          sessionStorage.setItem("token", token);
          dispatch(loginSuccess(token));
          const storedToken = sessionStorage.getItem("token");

          await getCsrfCookie();
          const xsrfToken = getCookie("XSRF-TOKEN");

          let config = {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${storedToken}`,
              "X-CSRF-TOKEN": xsrfToken,
            },
            credentials: "include",
          };
          return fetch(`${apiEndpoint}/user`, config)
            .then(checkHttpStatus)
            .then(parseJSON)
            .then((response) => {
              //Extract unique role names
              const roleNames = [
                ...new Set(
                  response.roles.map((role) => role.name.toLowerCase()),
                ),
              ];
              sessionStorage.setItem("roles", JSON.stringify(roleNames));

              // Extract unique permissions
              const permissions = [
                ...new Set(
                  response.roles.flatMap((role) =>
                    role.permissions.map((permission) => permission.name),
                  ),
                ),
              ];
              sessionStorage.setItem(
                "permissions",
                JSON.stringify(permissions),
              );
            });
        } catch (error) {
          console.log("Error: ", error);
          dispatch(loginError(error));
        }
      })
      .then(() => {
        dispatch(push(redirect));
      })
      .catch((error) => {
        dispatch(errorNotification(error));
        dispatch(loginError(error));
      });
  };
}

export const logout = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("roles");
  sessionStorage.removeItem("permissions");

  const xsrfToken = getCookie("XSRF-TOKEN");
  fetch(`${apiEndpoint}/auth/logout`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": xsrfToken,
    },
    credentials: "include",
  });

  return {
    type: LOGOUT,
  };
};
